<template>
  <v-expansion-panels :disabled="use_tcp" :value="use_tcp ? undefined : local_config.use_saas ? 0 : undefined" readonly >
    <v-expansion-panel @click="!any_loading ? local_config = {...local_config, use_saas: !local_config.use_saas} : ''" :title="use_tcp ? $t('Чтобы использовать SaaS XML, отключите режим разработчика.') : ''" >
      <v-expansion-panel-header hide-actions>
        <CheckBox 
          :disabled="use_tcp"
          :original_value="config.use_saas && !use_tcp"
          :value="local_config.use_saas && !use_tcp"
          readonly
          :hint="$t('Использовать для сохранения и оплаты заказов в r_keeper SaaS лицензирование XML интерфейса')"
          :label="$t('Использовать SaaS XML')"
          :loading="any_loading"
        />
        
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-divider></v-divider>
        <v-container fluid>
          <v-banner v-if="!saas_data.credentials" class="mb-5" color="warning" dark>
            <v-icon class="mr-3">mdi-comment-alert</v-icon>
            <T>Введите данные дилерской учетной записи l.ucs.ru</T><br>
            <T>Данные дилерской учетной записи не будут сохранены модулем доставки в открытом виде</T>
          </v-banner>
          <v-row>
           <v-col style="min-width: 300px">
              <v-form :disabled="any_loading" @submit.prevent="saveCredentials">
                <TextField
                 :rules="[rules.require]"
                  validate-on-blur
                  persistent-hint
                  v-model="user" 
                  clearable 
                  :label="$t('Логин l.ucs.ru (email)')" 
                  :hint="$t('Дилерская учетная запись должна иметь доступ к объекту на l.ucs.ru, для которого настраивается модуль доставки')" 
                />
                <TextField
                 :rules="[rules.require]" 
                  validate-on-blur
                  persistent-hint
                  v-model="password" 
                  password 
                  clearable 
                  :label="$t('Пароль l.ucs.ru')" 
                  :hint="$t('Дилерская учетная запись должна иметь доступ к объекту на l.ucs.ru, для которого настраивается модуль доставки')" 
                />
                <v-btn type="submit" text color="primary" :loading="any_loading">
                  <v-icon>mdi-license</v-icon>
                  <T>Отправить</T>
                </v-btn>
              </v-form>
            </v-col>
            <v-col style="min-width: 280px">
              <InfoField :loading="any_loading" :label="$t('Данные учетной записи')" :hint="$t('Заданы ли данные учетной записи l.ucs.ru')">
                <T style="color: var(--v-primary-base)" v-if="saas_data.credentials">Заданы</T>
                <T style="color: var(--v-error-base)" v-else>Не заданы</T>
              </InfoField>
              <InfoField :loading="any_loading" :label="$t('Дата окончания')" :hint="$t('Дата окончания SaaS XML лицензии по данным l.ucs.ru')">
                <DateSpan v-if="saas_data.license_expiration" :date="new Date(saas_data.license_expiration)" />
                <T v-else style="color: var(--v-error-base)">Данные о лицензии не найдены</T>
              </InfoField>
              <div style="color: var(--v-error-base)">{{saas_data.license_error}}</div>
              <v-btn :disabled="!config.use_saas" :loading="any_loading" text color="primary" @click="updateLicenseInfo">
                <v-icon>mdi-autorenew</v-icon>
                <T>Обновить данные</T>
              </v-btn>
            </v-col>
          </v-row>
          <v-divider class="my-5"></v-divider>
          <v-row>
            <v-col cols="12">
              <v-form :disabled="any_loading">
                <SelectField 
                  :rules="[rules.require]" 
                  :items="products_items" 
                  v-model="product_guid" 
                  :label="$t('Тип SaaS XML лицензии')" 
                  :hint="`${$t('Выберите тип SaaS XML лицензии, полученный на l.ucs.ru для текущего ресторана.\nУбедитесь, что лицензия не только получена, но и активирована!')}\n(${$t('Символом @ отмечены устаревшие лицензии, которые больше не выдаются UCS')})`" 
                />
                <v-btn @click="saveProduct" type="submit" text color="primary" :loading="any_loading">
                  <v-icon>mdi-license</v-icon>
                  <T>Отправить</T>
                </v-btn>
              </v-form>
            </v-col>
          </v-row>
          <!-- <v-divider class="my-5"></v-divider> -->
          <v-row>
            <v-col>
              <InfoField :label="$t('Обслуживание лицензии')" :hint="`${$t('Заменить идентификатор экземпляра - исправляет ошибку `лицензия удалена на сервере лицензирования`')}\n${$t('Обновить порядковый номер - исправляет ошибку `неправильно заполнен атрибут seqNum...`')}`" :loading="any_loading || !config.use_saas">
                <v-btn :disabled="!config.use_saas" :loading="any_loading" text color="primary" @click="updateInstanceGuid">
                  <v-icon>mdi-alert</v-icon>
                  <T>Заменить идентификатор экземпляра</T>
                </v-btn>
                <v-btn :disabled="!config.use_saas" :loading="any_loading" text color="primary" @click="updateSequenceNumber">
                  <v-icon>mdi-alert</v-icon>
                  <T>Обновить порядковый номер</T>
                </v-btn>
              </InfoField>
            </v-col>
          </v-row>
          <!-- <v-row>
            <v-col>
              <v-btn :disabled="!config.use_saas" :loading="any_loading" text color="primary" @click="updateInstanceGuid">
                <v-icon>mdi-alert</v-icon>
                <T>Заменить идентификатор экземпляра</T>
              </v-btn>
            </v-col>
            <v-col>
              <v-btn :disabled="!config.use_saas" :loading="any_loading" text color="primary" @click="updateSequenceNumber">
                <v-icon>mdi-alert</v-icon>
                <T>Обновить порядковый номер</T>
              </v-btn>
            </v-col>
          </v-row> -->
        </v-container>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import InfoField from '../../common/InfoField.vue'
import TextField from '../../common/TextField.vue'
import SelectField from '../../common/SelectField.vue'
import DateSpan from '../../header/DateSpan.vue'
import CheckBox from '../../common/CheckBox.vue'
import settings_group_mixin from '../settings_group_mixin'

import {mapGetters} from 'vuex'

export default {
  mixins: [settings_group_mixin],
  props:['use_tcp'],
  data: () => ({
    local_loading: false,
    user: '',
    password: '',
    product_guid: 0
  }),
  computed: {
    ...mapGetters(['saas_data']),
    any_loading(){
      return this.local_loading || this.loading
    },
    products_items(){
      if (this.saas_data.product_guid_reference) {
        return Object.entries(this.saas_data.product_guid_reference).map(([key, value]) => ({text: value, value: key}))
      } else return []
    }
  },
  watch: {
    local_config: {
      handler(val) {
        if (val.use_saas === true) {
          this.loadSaasData()
        }
      },
      deep: true
    }
  },
  methods: {
    async loadSaasData(){
      this.local_loading = true 
      try {
        await this.$store.dispatch('loadSaasData')
        this.product_guid = this.saas_data.product_guid
      } catch (e) {
        this.local_config = {...this.local_config, use_saas: false}
      } finally {
        this.local_loading = false
      }
    },
    async saveProduct(){
      this.local_loading = true 
      try {
        await this.$store.dispatch('updateSaasData', {product_guid: this.product_guid})
        this.product_guid = this.saas_data.product_guid

        this.$store.dispatch('throwTimeoutMessage', {
          message_data: this.$t('Изменения сохранены'),
          message_class: 'success'
        })
      } finally {
        this.local_loading = false
      }
    },
    async saveCredentials(){
      if (!this.user || !this.password) {
        this.$store.dispatch('throwTimeoutMessage', {
          message_data: this.$t('Пожалуйста, заполните логин и пароль дилерской учетной записи.'),
          message_class: 'error'
        })
        return
      }
      
      this.local_loading = true 
      try {
        await this.$store.dispatch('updateSaasData', {user: this.user, password: this.password})
        this.product_guid = this.saas_data.product_guid

        this.$store.dispatch('throwTimeoutMessage', {
          message_data: this.$t('Изменения сохранены'),
          message_class: 'success'
        })
      } finally {
        this.local_loading = false
      }
    },
    async updateInstanceGuid(){
      this.local_loading = true
      try {
        await this.$store.dispatch('updateInstanceGuid')

        this.$store.dispatch('throwTimeoutMessage', {
          message_data: this.$t('Идентификатор экземпляра ПО обновлен'),
          message_class: 'success'
        })
      } finally {
        this.local_loading = false
      }
    },
    async updateSequenceNumber(){
      this.local_loading = true
      try {
        await this.$store.dispatch('updateSequenceNumber')

        this.$store.dispatch('throwTimeoutMessage', {
          message_data: this.$t('Порядковый номер запроса обновлен'),
          message_class: 'success'
        })
      } finally {
        this.local_loading = false
      }
    },
    async updateLicenseInfo(){
      this.local_loading = true
      try {
        await this.$store.dispatch('updateLicenseInfo')

        this.$store.dispatch('throwTimeoutMessage', {
          message_data: this.$t('Данные о лицензии обновлены'),
          message_class: 'success'
        })
      } finally {
        this.local_loading = false
      }
    },
    validate(){
      if (!this.use_tcp && this.local_config.use_saas) {
        if (this.checkSaasDataState() === false) {
          throw new Error(this.$t('Данные SaaS XML заполнены не полностью, или не корректно'))
        }
      }
    },
    checkSaasDataState(){
      return true
    }
  },
  components:{
    TextField,
    CheckBox,
    SelectField,
    DateSpan,
    InfoField
  }
}
</script>